import { render, staticRenderFns } from "./vTabbedContent.vue?vue&type=template&id=72be2a87&scoped=true"
import script from "./vTabbedContent.vue?vue&type=script&lang=ts"
export * from "./vTabbedContent.vue?vue&type=script&lang=ts"
import style0 from "./vTabbedContent.vue?vue&type=style&index=0&id=72be2a87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be2a87",
  null
  
)

export default component.exports